import React from 'react'
import { Card } from 'react-bootstrap'
import * as estilos from '../../common/dashboard-estilos'
import BotonExportar from './boton-exportar'

/**
 * Tarjeta de indicador usada por ambos tableros.
 * Con `onExportar` muestra el ícono Excel que descarga los casos detrás del número (RG-602).
 */
const KpiCard = ({ label, value, subLabel, color = '#4F517A', onExportar, exportando = false }) => {
    return (
        <Card className='h-100' style={{ ...estilos.kpiCard, borderLeftColor: color }}>
            <Card.Body className='d-flex flex-column justify-content-center py-3' style={{ position: 'relative' }}>
                {onExportar && (
                    <BotonExportar
                        onClick={onExportar}
                        disabled={exportando}
                        style={{ position: 'absolute', top: 6, right: 8 }}
                    />
                )}
                <div style={estilos.kpiLabel}>{label}</div>
                <div style={{ ...estilos.kpiValue, color }}>
                    {value !== null && value !== undefined ? value : '—'}
                </div>
                {subLabel && (
                    <div className='text-muted' style={{ fontSize: '0.72rem', marginTop: 2 }}>{subLabel}</div>
                )}
            </Card.Body>
        </Card>
    )
}

export default KpiCard
